// extracted by mini-css-extract-plugin
export default {"wrapper":"DraggableModal_wrapper__XEoez"};